export default "__VITE_ASSET__uQJPVjGU__"